import loadable from "@loadable/component";
import type { FC } from "react";

import { CatalogSearchProvider } from "@unauthenticated/catalog/components";

import { SkeletonCatalogPage } from "./SkeletonCatalogPage";

const CatalogPage = loadable(() => import("./CatalogPageDefault"), {
  fallback: <SkeletonCatalogPage />,
});

const LazyCatalogPage: FC = () => {
  return (
    <CatalogSearchProvider>
      <CatalogPage />
    </CatalogSearchProvider>
  );
};

export { LazyCatalogPage };
